import './draw-svg.jquery.js';

export default function SVGDraw( $scope, $ ) {
	let wrapper = $( '.icon-svg-draw', $scope );

	if (! wrapper.length) {
		return;
	}
	let svg_icon = $( 'svg', wrapper ),
		settings = wrapper.data( 'settings' ),
		speed = settings.speed,
		is_loop = settings.loop,
		direction = settings.direction,
		offset = settings.offset,
		draw_interval,
		addOrSubtract,
		stepCount = 0,
		$doc = $( document ),
		$win = $( window ),
		max = $doc.height() - $win.height();

	function dashReset() {
		let largestDash = 0,
			largestPath = '';
		$( 'path', svg_icon ).each( function() {
			let dashArray = $( this ).css( 'stroke-dasharray' );
			let dashArrayValue = parseInt( dashArray );
			if (dashArrayValue > largestDash) {
				largestDash = dashArrayValue;
				largestPath = $( this );
			}
		} );

		if (largestDash < 3999 && largestDash / 2 > 600 && settings.fill === 'fill-svg') {
			let offset = largestPath.css( 'stroke-dashoffset' );
			offset = parseInt( offset );

			if (offset < largestDash / 2) {
				wrapper.addClass( settings.fill );
			}
		}
	}

	function stepProgress() {
		dashReset();
		if (addOrSubtract) {
			stepCount += 0.01;
			if (stepCount >= 1) {
				addOrSubtract = false;
				if (settings.fill === 'fill-svg') {
					wrapper.removeClass( 'fillout-svg' ).addClass( settings.fill );
				}
			}
		} else if (direction === 'restart') {
			stepCount = 0;
			addOrSubtract = true;
		} else {
			stepCount -= 0.01;
			if (stepCount <= 0) {
				addOrSubtract = true;
			}
		}
		// console.log(stepCount)
		return stepCount;
	}

	if (svg_icon.parent().hasClass( 'page-scroll' )) {
		$win.on( 'scroll', function() {
			let step = ( ( $win.scrollTop() - offset ) / max );
			let offsetTop = svg_icon.offset().top,
				viewPort = $win.innerHeight(),
				offsetBottom = offsetTop - viewPort;

			if (offsetTop > $win.scrollTop() && offsetBottom < $win.scrollTop()) {
				step = ( ( $win.scrollTop() - offset ) - offsetBottom ) / viewPort;
				svg_icon.drawsvg( 'progress', step );
			}
			dashReset();
		} );
	} else if (svg_icon.parent().hasClass( 'page-load' )) {
		let lastSvg = '';
		let drawSvg = setInterval( function() {
			let currentSvg = svg_icon.html();
			svg_icon.drawsvg( 'progress', stepProgress() );
			if (is_loop === 'no') {
				stepProgress();
			}
			if (currentSvg === lastSvg && is_loop === 'no') {
				wrapper.addClass( settings.fill );
				clearInterval( drawSvg );
			}
			lastSvg = currentSvg;
		}, speed );
	} else if (svg_icon.parent().hasClass( 'hover' )) {
		svg_icon.hover( function( e ) {
			e.stopPropagation();
			var re_hover = svg_icon.drawsvg( {
				duration: speed * 100,
				callback: function() {
					wrapper.addClass( settings.fill );
				},
			} );
			re_hover.drawsvg( 'animate' );
		}, function() {
		} );
	}
}
